var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frame"},[_c('Banner'),_c('BreadCrumb'),_c('div',{staticClass:"contain"},[_c('div',{staticClass:"w1280"},[_c('div',{staticClass:"navs"},_vm._l((_vm.navList),function(item){return _c('router-link',{key:item.name,class:{
            nav: true,
            on: item.templateDesc + '_' + item.id == _vm.$route.path,
          },attrs:{"to":item.templateDesc + '_' + item.id}},[_vm._v(_vm._s(item.name))])}),1),_c('div',{staticClass:"in",domProps:{"innerHTML":_vm._s(_vm.detail.contentStr)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }